import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserApi } from 'src/shared/sdk/services';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  constructor(
    private userApi: UserApi,
    private router: Router
  ) {
   if(!this.userApi.isAuthenticated()){
    this.router.navigate(["/"]);
   }
  }

  ngOnInit() {

  }
}
